// Source: https://github.com/atlassian/react-beautiful-dnd

import config from '../../config';

// all in pixels

// converts the percentages in the config into actual pixel values
export var getDistanceThresholds = function getDistanceThresholds(container, axis) {
  var startScrollingFrom = container[axis.size] * config.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
};
export default getDistanceThresholds;